<app-dialog>
  <p title>{{ dialogData.title }}</p>
  <p secondTitle *ngIf="dialogData.secondTitle" class="second-title">{{ dialogData.secondTitle }}</p>
  <p subtitle class="description">{{ dialogData.text }}</p>
  <div class="action-button" footer>
    @for (button of buttons; track button.text) {
      <button class="w-full" appButton [color]="button.color" (click)="onSubmit(button.action)">
        {{ button.text }}
      </button>
    }
  </div>
</app-dialog>
